import React, { ReactElement } from "react";

import {
  CheckboxFilter,
  ICheckboxFilterData,
  IFilterCallbackData,
  IRadioFilterData,
  IRangeFilterData,
  RadioFilter,
  RangeFilter,
  TFilterType,
  TFilterWithData,
  TileFilter,
} from "../../components";

export type TFilterWrapperType =
  | "dropdown-left"
  | "dropdown-right"
  | "accordion";

export interface IRenderFilterProps {
  filter: TFilterWithData;
  filterType?: TFilterWrapperType;
  onFilterChange(data: IFilterCallbackData): void;
}

export const renderFilter = ({
  filter,
  filterType = "accordion",
  onFilterChange,
}: IRenderFilterProps): ReactElement => {
  const templateMapping: { [name in TFilterType]: ReactElement } = {
    checkbox: (
      <CheckboxFilter
        key={filter.name}
        classes={filter.classes}
        variant={filter.variant}
        filterType={filterType}
        filterData={filter as ICheckboxFilterData}
        labels={{
          searchPlaceholder: "Search",
          showLess: "Show Less",
          showMore: "Show more",
          clearAll: "Clear All",
          ...(filter?.labels || {}),
        }}
        isAccordionExpanded={filter.expanded}
        hasSearch={(filter as ICheckboxFilterData).searchEnabled}
        hasShowMore={filterType === "accordion"}
        onChange={({ values, updates }) =>
          onFilterChange({
            categoryName: filter.categoryName,
            filterType: filter.type,
            name: filter.name,
            values,
            updates,
          })
        }
      />
    ),
    tile: (
      <TileFilter
        key={filter.name}
        classes={filter.classes}
        variant={filter.variant}
        filterType={filterType}
        filterData={filter as ICheckboxFilterData}
        labels={{
          clearAll: "Clear All",
        }}
        singleValue={(filter as ICheckboxFilterData).singleValue}
        isAccordionExpanded={filter.expanded}
        onChange={({ values, updates }) =>
          onFilterChange({
            categoryName: filter.categoryName,
            filterType: filter.type,
            name: filter.name,
            values,
            updates,
          })
        }
      />
    ),
    range: (
      <RangeFilter
        key={filter.name}
        classes={filter.classes}
        variant={filter.variant}
        filterType={filterType}
        filterData={filter as IRangeFilterData}
        isAccordionExpanded={filter.expanded}
        onChange={({ values, updates }) =>
          onFilterChange({
            categoryName: filter.categoryName,
            filterType: filter.type,
            name: filter.name,
            values,
            updates,
          })
        }
      />
    ),
    radio: (
      <RadioFilter
        key={filter.categoryName}
        classes={filter.classes}
        variant={filter.variant}
        filterType={filterType}
        isDisplaySelected={(filter as IRadioFilterData).isDisplaySelected}
        filterData={filter as IRadioFilterData}
        isAccordionExpanded={filter.expanded}
        labels={{
          searchPlaceholder: "Search",
          showLess: "Show Less",
          showMore: "Show more",
        }}
        onChange={({ values, updates }) => {
          onFilterChange({
            categoryName: filter.categoryName,
            filterType: filter.type,
            name: filter.name,
            values,
            updates,
          });
        }}
      />
    ),
  };

  return templateMapping[filter.type];
};
